import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      const { id, name } = event?.data || {}
      this.$router.push({
        name: 'AlarmView',
        params: {
          id
        },
        query: {
          alarm: name || DEFAULT_EMPTY_VALUE
        }
      }).then()
    },

    onAlarmActivation (event) {
      const { deactivated_at: deactivatedAt, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('satellite-tracking/alarm.deactivate') : this.$t('satellite-tracking/alarm.activate')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('satellite-tracking/alarm.confirm_deactivation') : this.$t('satellite-tracking/alarm.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.alarmActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async alarmActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.alarms || {}
        await api('satellite-tracking').patch(`alarms/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onAlarmDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('satellite-tracking/alarm.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('satellite-tracking/alarm.confirm_removal'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.alarmDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async alarmDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.alarms || {}

        await api('satellite-tracking').delete(`alarms/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
